//This file is for application independent commonly used variables and functions

import { message } from "antd";
import CryptoJS from "crypto-js";
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

import Cookies from 'js-cookie';
//Notifiers
export const ErrorMessage = (content) => {
  message.error(content);
}

export const SuccessMessage = (content) => {
  message.success(content);
}

export const InfoMessage = (content) => {
  message.info(content);
}

export const WarnMessage = (content) => {
  message.warning(content);
}
export const decrypt = (cipherText) => {
  if (!cipherText) {
    console.error("CipherText is undefined or null");
    return ""; // Handle undefined value gracefully
  }
  const encryptionKey = "code";

  // Ensure the Base64-encoded string is valid
  cipherText = cipherText.replace(/ /g, "+");

  // Convert from Base64
  const cipherBytes = CryptoJS.enc.Base64.parse(cipherText);

  // Use the same salt as in .NET (hex-encoded)
  const salt = CryptoJS.enc.Hex.parse("4976616e204d65647665646576");

  // Generate Key and IV using PBKDF2 (same as .NET Rfc2898DeriveBytes)
  const keySize = 256 / 8; // 32 bytes
  const ivSize = 128 / 8; // 16 bytes

  const keyAndIV = CryptoJS.PBKDF2(encryptionKey, salt, {
    keySize: (keySize + ivSize) / 4, // 32-byte key + 16-byte IV (total 48 bytes)
    iterations: 1000,
    hasher: CryptoJS.algo.SHA1,
  });

  const key = CryptoJS.lib.WordArray.create(
    keyAndIV.words.slice(0, keySize / 4)
  ); // First 32 bytes
  const iv = CryptoJS.lib.WordArray.create(
    keyAndIV.words.slice(keySize / 4, (keySize + ivSize) / 4)
  ); // Next 16 bytes

  // Decrypt using AES in CBC mode
  const decrypted = CryptoJS.AES.decrypt(
    { ciphertext: cipherBytes } , // CipherParams object
    key,
    { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
  );

  // Convert from WordArray to UTF-16LE string (to match .NET encoding)
  return decrypted.toString(CryptoJS.enc.Utf16LE);
};
export const User_Roles = {
  Normal_User:"User",
  Super_User:"Super User",
  Client_User:"Client User",
  TimecardFollowup_User:"Timesheet Coordinator"
}

//Util for replacing underscore with space in strings
export const ReplaceUnderscoreWithSpace = (text) => {
  if (!(text === null || text === undefined || text.trim() === "")) {
    return text.replace("_", " ");
  }
};

//Util for validating whether a string is null, empty and undefined 
export const StringValidations = (text) =>{
  if (text === null || text === undefined || text.trim() === "" ) {
    return false;
  }
  else{
    return true;
  }
}

// Get Current Date
export const GetDefaultDate = () => {
  let date = new Date();
  const options = {
    year:"numeric",
    month:"2-digit",
    day:"2-digit"
  };
  let currentDate = date.toLocaleDateString('en-US', options);
  return currentDate;
}

 
export const decodeRoute = (encodedRoute) => decodeURIComponent(encodedRoute);
// routeUtils.js

// export const encryptRoute = (key) => encodeURIComponent(routes[key] || key);


export const encryptRoute = (route) => encodeURIComponent(route);
// Define routes dynamically with encryption
export const routes = {
  dashboard: encryptRoute("d/as/h/bo/a/rd"),
  adminDashboard: encryptRoute("ad/min/da/sh/bo/ar-d"),
  timecardFollowup: encryptRoute("tim/ec/ard-fol/low/up/cra/wli/ng"),
  timesheetTeam: encryptRoute("ti/me/sh/ee/t-te/am"),
  clientServices: encryptRoute("cli/ent/ser/vi/ces"),
  employeeCare: encryptRoute("em/plo/yee/ca/re"),
  timecards: encryptRoute("ti/me/car"),
  sendOtp: encryptRoute("se/nd/ot/p"),
  verifyMail: encryptRoute("ve/ri/fy/ma/il"),
  resetPassword: encryptRoute("re/se/t/pa/ss"),
  verifyOtp: encryptRoute("ve/ri/fy/ot/p"),
  passwordConfirmation: encryptRoute("pa/ss/wo/rd/co"),
  adjustmentsFile: encryptRoute("ad/ju/st/me/nts/fi/le"),
  masterFile: encryptRoute("ma/st/er/fi/le"),
  auditReport: encryptRoute("au/dit/re/po/rt"),
  selectedReports: encryptRoute("se/le/ct/ed/re/po/rts"),
  utilitiesTools: encryptRoute("ut/il/it/ies/to/ols"),
  previewReview: encryptRoute("pr/ev/iew/re/vi/ew"),
  payrollChecklist: encryptRoute("pa/yr/oll/che/ckl/ist"),
  payrollHoursAudit: encryptRoute("pay/ro/ll/hou/rs-aud/it"),
  activityLog: encryptRoute("ac/ti/vi/ty/log"),
  healthInsurance: encryptRoute("he/al/th/in/su/ra/nce"),
  updateCredentialGrid: encryptRoute("up/da/te/cr/ed/en/ti/al-gr/id"),
  garnishmentsManagement: encryptRoute("ga/rn/is/hm/en/ts/ma/na/ge/me/nt"),
  finalMasterAudit: encryptRoute("fi/nal/ma/st/er/au/dit"),
  newHiresReHires: encryptRoute("ne/w-hir/es/re-hi/res"),
  offCycleReport: encryptRoute("of/f-cy/cle/re/port"),
  monitorDashboard: encryptRoute("mon/it/or/das/hb/oard"),
  statutoryReporting: encryptRoute("st/atu/tory/rep/ort/ing"),
  prReports: encryptRoute("pr/re/po/rts"),
  prReportBMS: encryptRoute("pr-re/po/rt/bms"),
  prReportAbbott: encryptRoute("pr-re/po/rt/ab/bo/tt"),
  prReportIntegra: encryptRoute("pr-re/po/rt/in/te/gra"),
  prReportHPE: encryptRoute("pr-re/po/rt/hpe"),
  prReportsHomePage: encryptRoute("pr-re/por/ts/ho/me/page"),
  billingData: encryptRoute("bil/li/ng/da/ta"),
  billingCrawling: encryptRoute("bi/ll/ing/cra/wl/ing"),
  billingMasterFile: encryptRoute("bi/ll/ing/ma/st/er-fi/le"),
  billingInvoiceUpload: encryptRoute("bil/li/ng/in/voi/ce-up/lo/ad"),
  reportingTable: encryptRoute("repo/rti/ng/ta/ble"),
  paidVsBilled: encryptRoute("pa/id-vs-bi/ll/ed"),
  userManagement: encryptRoute("us/er/man/age/ment"),
  contingentExpenseManagement: encryptRoute("con/tin/gent/exp/ense-man/age/ment"),
  corporateExpenseManagement: encryptRoute("cor/por/ate/expe/nse-mana/gem/ent"),
  expenseManagement: encryptRoute("expe/nse/mana/gem/ent"),
  glCodes: encryptRoute("gl/cod/es"),
  analyticsGraphs: encryptRoute("ana/lyt/ics/gra/phs"),
  calendarView: encryptRoute("cal/en/dar/vi/ew"),
  tenNinetyNineTax: encryptRoute("10/99/tax"),
  tenNinetyNineMasterFile: encryptRoute("10/99/ma/st/er-fi/le"),
  tenNinetyNineCrawl: encryptRoute("10/99/cr/awl"),
  canadaAutoCrawl: encryptRoute("ca/na/da/au/to-cr/awl"),
  canadaMasterFile: encryptRoute("ca/na/da/mas/ter-fi/le"),
  consolidatedData: encryptRoute("con/so/li/dat/ed/da/ta"),
  canadaPayroll: encryptRoute("ca/na/da/pa/yr/oll"),
  analyticsGraphsV2: encryptRoute("an/al/yti/cs/gr/ap/hs-v2"),
};

// src/constants/pageCssMap.js
export const pageCssMap = {
  login: "Login",
  updatecredentialgrid: "GridCredentialUpdate",
  dashboard:"Dashboard",
  offcycle:"Offcycle",
  timecards:"Timecards",
  dashboard:"Dashboard",
 utilities:"Utilities",
 userManagement:"UserManagement",
 1099:"1099",
 

};



export const useTenantStyle = () => {
  const location = useLocation();

  useEffect(() => {
    console.log("🔍 useTenantStyle triggered with pathname:", location.pathname);
    
    const tenant = (Cookies.get("tenant_name") || location.pathname.split('/')[1] || "default").toUpperCase();
    const routePage = location.pathname.split('/')[2] || "home";

    console.log("📦 Tenant:", tenant, "| Page:", routePage);

    const cssFile = pageCssMap[routePage.toLowerCase()];
    if (!cssFile) {
      console.warn("⚠️ No CSS mapping found for page:", routePage);
      return;
    }

    import(`../GlobalCss/${tenant}/${cssFile}.css`)
      .then(() => {
        console.log(`✅ Loaded CSS: ${tenant}/${cssFile}`);
      })
      .catch((err) => {
        console.error(`❌ Could not load CSS for ${tenant}/${cssFile}`, err);
      });

  }, [location]);
};

